import axios from 'axios';

import { handleApiSucess, handleApiError, getRequestHeaders } from 'api/util.api';
import { handleRequest } from './util.api';

const getSubcompaniesUrl = (companyId) => `/companies/${companyId}/subcompanies`;

const addSubcompanyUrl = (companyId) => `/companies/${companyId}/subcompanies`;

const getSubcompanyUrl = (companyId, subcompanyId) =>
  `/companies/${companyId}/subcompanies/${subcompanyId}`;

const editSubcompanyUrl = (companyId, subcompanyId) =>
  `/companies/${companyId}/subcompanies/${subcompanyId}`;

const toggleSubcompanyUrl = (companyId, subcompanyId) =>
  `/companies/${companyId}/subcompanies/${subcompanyId}/toggle`;

const deleteSubcompanyUrl = (companyId, subcompanyId) =>
  `/companies/${companyId}/subcompanies/${subcompanyId}`;

const service = {
  configure(endpoint = '', auth = {}, defaultHeaders = {}) {
    this.endpoint = endpoint;
    this.auth = auth;
    this.defaultHeaders = defaultHeaders;
    this.getHeaders = getRequestHeaders(this.auth, this.defaultHeaders);

    this.axios = axios.create({
      baseURL: this.endpoint,
      timeout: 30000,
    });

    this.axios.interceptors.request.use((request) => {
      handleRequest(request);
      return request;
    });

    return this;
  },

  getSubcompanies(companyId) {
    const url = getSubcompaniesUrl(companyId);
    return this.axios
      .get(url, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  get(companyId, subcompanyId) {
    const url = getSubcompanyUrl(companyId, subcompanyId);
    return this.axios
      .get(url, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  add(companyId, data) {
    const url = addSubcompanyUrl(companyId);
    return this.axios
      .post(url, data, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  edit(companyId, subcompanyId, data) {
    const url = editSubcompanyUrl(companyId, subcompanyId);
    return this.axios
      .put(url, data, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  toggle(companyId, subcompanyId) {
    const url = toggleSubcompanyUrl(companyId, subcompanyId);
    return this.axios
      .put(url, {}, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  delete(companyId, subcompanyId) {
    const url = deleteSubcompanyUrl(companyId, subcompanyId);
    return this.axios
      .delete(url, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },
};

export default service;



// WEBPACK FOOTER //
// src/lib/api/subcompanies.api.js